import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";

export default function BillingCancel() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center" data-testid="billing-cancelled">
          <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mx-auto">
            <XCircle className="w-8 h-8 text-slate-500" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mt-6">Checkout cancelled</h1>
          <p className="text-slate-500 mt-2">No charges were made. Ready to try again?</p>
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/pricing">
              <Button className="rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold">
                Back to pricing
              </Button>
            </Link>
            <Link to="/dashboard">
              <Button variant="outline" className="rounded-xl">
                Back to dashboard
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
